// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ButtonController from "./button_controller"
application.register("button", ButtonController)

import CollapsibleMenuController from "./collapsible_menu_controller"
application.register("collapsible-menu", CollapsibleMenuController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import PlayerSortController from "./player_sort_controller"
application.register("player-sort", PlayerSortController)

import RosterSortController from "./roster_sort_controller"
application.register("roster-sort", RosterSortController)

import StopPropagationController from "./stop_propagation_controller"
application.register("stop-propagation", StopPropagationController)

import TeamSortController from "./team-sort_controller"
application.register("team-sort", TeamSortController)

import TeamTabsController from "./team_tabs_controller"
application.register("team-tabs", TeamTabsController)
